var React = require('react');

function CloseRound (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17 28.9535C23.6017 28.9535 28.9535 23.6017 28.9535 17C28.9535 10.3984 23.6017 5.04663 17 5.04663C10.3984 5.04663 5.04663 10.3984 5.04663 17C5.04663 23.6017 10.3984 28.9535 17 28.9535Z","strokeWidth":"1.59601","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M21.1614 12.7148L12.6826 21.1936","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M12.6826 12.7148L21.1614 21.1936","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

CloseRound.defaultProps = {"viewBox":"0 0 34 34"};

module.exports = CloseRound;

CloseRound.default = CloseRound;
